import { render, staticRenderFns } from "./reservation_information_reflected.vue?vue&type=template&id=25207b22&scoped=true&"
import script from "./reservation_information_reflected.vue?vue&type=script&lang=js&"
export * from "./reservation_information_reflected.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25207b22",
  null
  
)

export default component.exports